import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';

import {CONFIG} from 'src/global-config';
import {DashboardLayout} from 'src/layouts/dashboard';

import {LoadingScreen} from 'src/components/loading-screen';

import {AccessGuard, AuthGuard, RoleBasedGuard} from 'src/auth/guard';
import {RedashRDBDashboardView} from "../../sections/analytics/view";


// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/storage'));

//
const StoragePage = lazy(() => import('src/pages/dashboard/storage'));

//
const LabelEventsPage = lazy(() => import('src/pages/dashboard/queues/label-events-view'));

const WeightEventsPage = lazy(() => import('src/pages/dashboard/queues/weight-events-view'));

const UsersPage = lazy(() => import('src/pages/dashboard/users'));

const SettingsPage = lazy(() => import('src/pages/dashboard/settings'));

const TaraWeightsPage = lazy(() => import('src/pages/dashboard/settings/tara-weights'));

const RedashDashboardPage = lazy(() => import('src/pages/dashboard/analytics/redash'));

const RedashRDBDashboardPage = lazy(() => import('src/pages/dashboard/analytics/redash-rdb'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen/>}>
      <Outlet/>
    </Suspense>
  </DashboardLayout>
);

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      {element: <IndexPage/>, index: true},
      {path: 'storage', element: <StoragePage/>},
      {path: 'users', element: (
          <RoleBasedGuard acceptRoles={['admin']} hasContent>
            <UsersPage/>
          </RoleBasedGuard>
        )},
      {
        path: 'settings',
        children: [
          {
            element: (
              <RoleBasedGuard acceptRoles={['admin', 'operator']} hasContent>
                <SettingsPage />
              </RoleBasedGuard>
            ),
            index: true,
          },
          {
            path: 'tara-weights',
            element: (
              <RoleBasedGuard acceptRoles={['admin', 'operator']} hasContent>
                <TaraWeightsPage />
              </RoleBasedGuard>
            ),
          },
        ],
      },
      {path: 'events/label', element: <LabelEventsPage/>},
      {path: 'events/waage', element: <WeightEventsPage/>},
      {path: 'analytics/restmenge', element: <RedashDashboardPage /> },
      {path: 'analytics/mbg-events', element: ( <RedashRDBDashboardPage /> )},
    ],
  },
];
/** {/* <AccessGuard acceptGroups={['Demo']} hasContent>}
<RedashDashboardPage />
{/*}</AccessGuard>}
*/
